import { createClient } from "@supabase/supabase-js";

// External Supabase project (madcaptains).
// URL and anon key are publishable values — safe to ship in client bundle.
// RLS protects all data access.
const SUPABASE_URL = "https://ccjhcgduehdpesozmurd.supabase.co";
const SUPABASE_PUBLISHABLE_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNjamhjZ2R1ZWhkcGVzb3ptdXJkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODEwMzM1ODEsImV4cCI6MjA5NjYwOTU4MX0.hu2Sb2YMyXxaJffgatzeTqumwN0V4uXLK7DjcNAQYUs";

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: typeof window !== "undefined",
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: typeof window !== "undefined" ? window.localStorage : undefined,
  },
});

export const SUPABASE_PROJECT_URL = SUPABASE_URL;